import React, { useState } from 'react'
import GenericIcon from 'components/GenericIcon'
import { presenceErrorClass, isEmail, isMobile } from 'servos/formValidations'
import axios from 'axios'
import { getTrackingId } from 'utils/tracking'

const HubspotContactForm = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [question, setQuestion] = useState('');
  const [errors, setErrors] = useState({});
  const [hasFormSent, setHasFormSent] = useState(false);

  const sendButtonText = hasFormSent ? 'Send again' : 'Send'

  const onChatToUsClick = (e) => {
    if (e.target.id === 'hubspot-chat') {
      window.HubSpotConversations.widget.open()
    }
  }

  const onChangeFirstName = (e)  => {
    setFirstName(e.target.value)
    setErrors({})
  }

  const onChangeLastName = (e)  => {
    setLastName(e.target.value)
    setErrors({})
  }

  const onChangeEmail = (e)  => {
    setEmail(e.target.value)
    setErrors({})
  }

  const onChangeQuestion = (e)  => {
    setQuestion(e.target.value)
    setErrors({})
  }

  const validateName = (errors) => {
    if (firstName.length === 0) {
      errors['firstName'] = I18n.t('onboarding.registration.errors.name.presence')
    }

    if (lastName.length === 0) {
      errors['lastName'] = I18n.t('onboarding.registration.errors.name.presence')
    }
  }

  const validateEmail = (errors, value) => {

    if ( email.length === 0) {
      errors['email'] = I18n.t('onboarding.registration.errors.email.presence')
    }

    if ( (email.length > 0 && !isEmail(email)) ) {
      errors['email'] = I18n.t('onboarding.registration.errors.email.format')
    }
  }

  const validateQuestion = (errors) => {
    if ( !(question.length > 0) ) {
      errors['question'] = I18n.t('onboarding.registration.errors.enquiry.presence')
    }
  }

  const isValid = () => {
    let errors = {}
    validateName(errors)
    validateEmail(errors)
    validateQuestion(errors)

    setErrors(errors)
    return Object.keys(errors).length === 0
  }

  const onSubmit = () => {
    if (hasFormSent) {
      setHasFormSent(false)
    }

    if (!hasFormSent) {
      if (isValid()) {
        const msclkid = getTrackingId('msclkid')
        const hubSpotData = {
          submittedAt: new Date(),
          fields: [
            {
              name: 'email',
              value: email
            },
            {
              name: 'firstname',
              value: firstName
            },
            {
              name: 'lastname',
              value: lastName
            },
            {
              name: 'enquiry',
              value: question
            },
            ...(msclkid ? [{
              name: 'msclkid',
              value: msclkid
            }] : [])
          ],
        }

        setHasFormSent(true)
        setFirstName('')
        setLastName('')
        setEmail('')
        setQuestion('')

        const hubSpotURI = 'https://api.hsforms.com/submissions/v3/integration/submit/6007498/ae582533-1ebe-4d08-a377-a1692d375ce2'
        axios.post(hubSpotURI, hubSpotData)
        .then(response => {
          console.log(response)
        })
        .catch(error => {
          console.log(error)
        })
      }
    }
  }

  return (
    <div className="hubspot-form-container mt-3 mb-5">
      <div className="row">
        <div className="col-sm-5 mb-5">
          <h3 className="get-in-touch-text">Get in touch with us</h3>
          <button 
            className='btn btn-lg btn-green mt-4 mb-4'
            onClick={ () => { Calendly.showPopupWidget('https://calendly.com/yard_au');return false; } }
          >
            <span className='send-text'>Talk to an expert</span>
          </button>
        </div>
        <div className="col-sm-4 mb-5">
          <div className="bigger mb-4"><b>Contact us</b></div>
          <div 
            className="mt-1 mb-4 pointer"
            onClick={ () => { Calendly.showPopupWidget('https://calendly.com/yard_au');return false; } }
          >
            <GenericIcon className='generic-icon' name='smallPhone' />Book an appointment
          </div>
          <div 
            id='hubspot-chat'
            className="mb-4 pointer"
            onClick={onChatToUsClick}
          >
            <GenericIcon id={'hubspot-chat'} className='generic-icon thicker' name='chat' />
            Chat to us online
          </div>
          <div className="mb-5"><GenericIcon className='generic-icon' name='mail' />Email us</div>
          <div className="mb-4 mr-1">New loan enquiries: <a href='mailto:hello@yard.com.au'>hello@yard.com.au</a></div>
          <div className="mb-4 mr-1">Service requests: <a href='mailto:help@yard.com.au'>help@yard.com.au</a></div>
        </div>
        <div className="col-sm-3">
          <div className="bigger mb-4"><b>Other questions?</b></div>

          {hasFormSent ? 
            <div className="mb-3">
              <div>Thank you!</div>
              <div>Your enquiry is already in our priority mailbox, we will contact you very soon!</div>
            </div> 
            :
            <div>
              <div className='form-group'>
                <input className={ `form-control ${presenceErrorClass(errors['firstName'])}` }
                       type="text"
                       placeholder="First name"
                       onChange={ (e) => { onChangeFirstName(e) } }
                       value={ firstName } />
                <div className="invalid-feedback">
                  { errors['firstName'] }
                </div>
              </div>
              <div className='form-group'>
                <input className={ `form-control ${presenceErrorClass(errors['lastName'])}` }
                       type="text"
                       placeholder="Last name"
                       onChange={ (e) => { onChangeLastName(e) } }
                       value={ lastName } />
                <div className="invalid-feedback">
                  { errors['lastName'] }
                </div>
              </div>
              <div className='form-group'>
                <input className={ `form-control ${presenceErrorClass(errors['email'])}` }
                       type="text"
                       placeholder="Email"
                       onChange={ (e) => { onChangeEmail(e) } }
                       value={ email } />
                <div className="invalid-feedback">
                  { errors['email'] }
                </div>
              </div>
              <div className='form-group'>
                <textarea className={ `form-control ${presenceErrorClass(errors['question'])}` }
                       type="area"
                       placeholder="Your questions"
                       onChange={ (e) => { onChangeQuestion(e) } }
                       value={ question } />
                  <div className="invalid-feedback">
                    { errors['question'] }
                  </div>
              </div>
            </div>

          }

          <button className='btn btn-green btn-lg hover-dark-green' onClick={onSubmit}>
            <GenericIcon className='mr-1 send-icon' name='sendIcon' />
              <span className='send-text'>{sendButtonText}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default HubspotContactForm;
